import { IIconBase } from '..'

const considerarIcon = ({
  color = '#664D03',
  height = 40,
  width = 41,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M28.5332 3.3335H12.4665C8.91654 3.3335 6.0332 6.2335 6.0332 9.76683V33.2502C6.0332 36.2502 8.1832 37.5168 10.8165 36.0668L18.9499 31.5502C19.8165 31.0668 21.2165 31.0668 22.0665 31.5502L30.1999 36.0668C32.8332 37.5335 34.9832 36.2668 34.9832 33.2502V9.76683C34.9665 6.2335 32.0832 3.3335 28.5332 3.3335Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.4824 18.3332L18.9824 20.8332L25.6491 14.1665'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default considerarIcon
